import Delivery  from '../img/delivery.png';
import Community from '../img/community.png';
import Authentic from '../img/authentic.png';

export const serviceData = [
    { 
        id : 1, 
        title : 'Close Community', 
        desc : 'We have integrated a community function which gets everyone social. Shopping should be easy and fun, but who says it has to end there? Now you can interact with the community via reviews, provide direct feedback to designers, and upvote or downvote items. This helps us improve your experience. Awesome right?',
        imageSrc : Community
    },
    { 
        id : 2, 
        title : 'Shop Authentic Items', 
        desc : 'With all our quality checks in place, we are giving you our gauarantee that you will only get authentic items. We will not sell fake items, nor would we will sell any items that are not certified to our standards. This way, we make sure the best products across Africa gain the attention and patronage they deserve.',
        imageSrc : Authentic
    },

    { 
        id : 3, 
        title : 'Global Delivery', 
        desc : 'In order to bring our vision to life, we have optimized our delivery process to ensure we handle and deliver your products in the safest and fastest way possible. Best global routes, safe shipment handling, and quick delivery are the key to our success. From premium to standard, we have the best delivery options available.',
        imageSrc : Delivery
    },
] 

export const imageData = [
    {
      id: 1,
      image: "/hero7.jpg",
      title: "We are Africa!",
      desc: "The largest collection of the best in African fashion globally. From designers, to models and craftsmen, we are home to all."
    },
  
    {
      id: 2,
      image: "/hero6.jpg",
      title: "Shop Authentic Brands",
      desc: "Providing access to authentic products verified by us. This means you shop stress free and get the best quality."
    },
    {
        id: 3,
        image: "/hero3.jpg",
        title: "Unbeatable Discounts",
        desc: "With massive discounts and sales, you are guaranteed to keep adding products to your cart."
      },
    
      {
        id: 4,
        image: "/hero4.jpg",
        title: "Fast Shipping",
        desc: "Premium fast shipping and handling of all products in your cart. We take pride in ensuring your order satisfaction."
      },
      {
        id: 5,
        image: "/hero5.jpg",
        title: "Widest Categories",
        desc: "Every category you can think of, we've got it covered. From pure fashion fits to accessories and bespoke, we've got it all."
      },
      {
        id: 6,
        image: "/hero1.jpg",
        title: "Best Eco-system",
        desc: "We are set to be the best fashion ecoststem connecting Africa to the world with an all new intuitive approach to our Community and Blog."
      },
      {
        id: 7,
        image: "/hero2.jpg",
        title: "Coming Soon",
        desc: "With our beta app launch coming soon, subscribe to our newsletter to stay updated and be one of the very first."
      }
]

